import http from "./http-common";

class DocConService {
    upload(file, documentType, productNumber, companyId) {
        const formData = new FormData();
        formData.append("file", file); // must match multer field name
        formData.append("documentName", file.name);
        formData.append("documentType", parseInt(documentType));
        formData.append("productNumber", productNumber);
        formData.append("companyId", companyId);

        // IMPORTANT: Do NOT set Content-Type manually. Let the browser add the boundary.
        return http.post("/uploadDocument", formData,
            {
                headers: {
                    "Content-type": "multipart/form-data"
                }
            }
        );
    }

    getDocuments(companyId, productNumber, documentType) {
        let url = `/getDocuments?companyId=${encodeURIComponent(companyId)}`;
        if (productNumber && productNumber.trim().length > 0) {
            url += `&productNumber=${encodeURIComponent(productNumber)}`;
        }
        if (documentType) {
            url += `&documentType=${encodeURIComponent(documentType)}`;
        }
        return http.get(url);
    }

    deleteDocument(id) {
        return http.delete(`/deleteDocument/${id}`);
    }
}

export default new DocConService();